<template>
    <div class="container mt-4">

            <div class="row">
                <div class="col-12 col-md-6 mb-4">
                    <!-- Material form register -->
                    <form class="card form-card">
                        <p class="h4 text-center mb-4">Giriş Yap</p>
                        <div class="red-text" v-show="nologin">
                            E-posta ve şifreniz uyuşmuyor. Lütfen tekrar giriş yapın
                        </div>
                        <div class="grey-text">
                            <mdb-input label="E-posta Adresiniz" icon="envelope" type="email" v-model="login.email" />
                            <div class="red-text" v-show="email">
                                Lütfen E-posta alanını doğru şekilde giriniz.
                            </div>
                            <mdb-input label="Şifreniz" icon="lock" type="password" v-model="login.password" />
                            <div class="red-text" v-show="password">
                                Lütfen Şifrenizi boş bırakmayınız.
                            </div>
                        </div>
                        <div class="text-center">
                            <mdb-btn color="primary" type="button" @click="loginIn">Giriş</mdb-btn>
                        </div>
                    </form>
                    <!-- Material form register -->
                </div>

                <div class="col-12 col-md-6 ">
                    <!-- Material form register -->
                    <form class="card form-card">
                        <p class="h4 text-center mb-4">Kayıt Ol</p>
                        <div class="red-text" v-show="nologinR">
                            {{message}}
                        </div>
                        <div class="grey-text">
                            <mdb-input label="Adınız Soyadınız" icon="user" type="text" v-model="register.name" />
                            <div class="red-text" v-show="nameR">
                                Lütfen Ad Soyad alanını doldurunuz.
                            </div>
                            <mdb-input label="E-posta Adresiniz" icon="envelope" type="email" v-model="register.email" />
                            <div class="red-text" v-show="emailR">
                                Lütfen E-posta alanını doğru şekilde giriniz.
                            </div>
                            <mdb-input label="Şifreniz" icon="lock" type="password" v-model="register.password" />
                            <div  v-show="passwordR">
                                <p class="red-text">
                                    Lütfen Şifrenizi boş bırakmayınız.
                                </p>
                            </div>
                        </div>
                        <div class="text-center">
                            <mdb-btn color="primary" type="button" @click="registerIn">Kayıt Ol</mdb-btn>
                        </div>
                    </form>
                    <!-- Material form register -->
                </div>
            </div>

    </div>

</template>

<script>
    import { mdbInput, mdbBtn,mdbJumbotron,mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon } from 'mdbvue';
    import axios from "axios";
    export default {
        name: 'Register_Login',
        components: {
            mdbInput,
            mdbJumbotron,
            mdbBtn,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody,
            mdbIcon
        },
        data() {
            return {
                message:"",
                nologin:false,
                email:false,
                password:false,
                nologinR:false,
                nameR:false,
                emailR:false,
                passwordR:false,
                login:{
                    email:"",
                    password:""
                },
                register:{
                    name:"",
                    email:"",
                    password:""
                },

            }
        },
        methods:{
            async loginIn(){
                this.password = false;
                this.email = false;
                if(this.login.email !== "" && this.login.password !== ""){
                    var self =this;
                    await axios.post("https://www.biletbul.com/backend/public/api/v1/login",{
                        email:this.login.email,
                        password:this.login.password
                    })
                        .then(function (response) {
                            if(response.data.status === false){
                                self.nologin = true;
                            }else{
                                localStorage.api_token = response.data.data.api_token;
                                localStorage.user_name = response.data.data.name;
                                localStorage.user_email = response.data.data.email;
                                window.location = "/";
                            }
                        })
                        .catch(error => {
                            self.nologin = true;
                            //self.$router.go(-1);
                        })
                }else{
                    if(this.login.email === ""){
                        this.email = true;
                    }
                    if(this.login.password === ""){
                        this.password = true;
                    }

                }

            },
            async registerIn(){
                this.passwordR = false;
                this.emailR = false;
                this.nameR = false;
                if(this.register.name !== "" && this.register.email !== "" && this.register.password !== ""){
                    var self =this;
                    await axios.post("https://www.biletbul.com/backend/public/api/v1/register",{
                        name:this.register.name,
                        email:this.register.email,
                        password:this.register.password
                    })
                        .then(function (response) {
                            if(response.data.status === false){
                                self.nologinR = true;
                                self.message = response.data.message;
                            }else{
                                localStorage.api_token = response.data.data.api_token;
                                localStorage.user_name = self.register.name;
                                localStorage.user_email = self.register.email;
                                window.location = "/";
                            }
                        })
                        .catch(error => {
                            self.nologinR = true;
                            //self.$router.go(-1);
                        })
                }else{
                    if(this.register.name === ""){
                        this.nameR = true;
                    }
                    if(this.register.email === ""){
                        this.emailR = true;
                    }
                    if(this.register.password === ""){
                        this.passwordR = true;
                    }

                }

            }
        },
        mounted() {
            if(localStorage.user_name){
                window.location.href = "/#/";
            }
        }
    }
</script>

<style scoped>
.form-card{
    padding: 15px;
    min-height: 360px;
}
</style>
